var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVuesaxOutlineMoneys(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "{props.color}",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.1 18.22c-.52 0-1.01-.05-1.45-.15a3.74 3.74 0 0 1-.8-.22c-1.33-.5-2.9-1.73-2.9-4.79V7.91c0-3.27 1.88-5.15 5.15-5.15h8.79c2.76 0 4.54 1.32 5.02 3.72.09.44.13.91.13 1.43v5.15c0 3.29-1.87 5.16-5.15 5.16H6.1zM2.46 7.93v5.15c0 1.79.63 2.89 1.92 3.38.2.07.39.12.57.15.38.08.75.12 1.16.12h8.79c2.46 0 3.65-1.19 3.65-3.65V7.93c0-.42-.03-.79-.1-1.13-.34-1.7-1.5-2.52-3.55-2.52H6.11c-2.46 0-3.65 1.19-3.65 3.65z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.101 21.22c-.85 0-1.61-.12-2.26-.37-1.47-.55-2.43-1.71-2.76-3.37a.74.74 0 0 1 .21-.68.73.73 0 0 1 .69-.19c.33.07.7.11 1.12.11h8.79c2.46 0 3.65-1.19 3.65-3.65V7.92c0-.42-.03-.79-.1-1.13-.05-.25.03-.5.2-.68.18-.18.43-.26.68-.2 2.4.49 3.72 2.27 3.72 5.01v5.15c0 3.28-1.87 5.15-5.15 5.15h-8.79zm-1.72-1.77c.48.18 1.06.27 1.73.27h8.79c2.46 0 3.65-1.19 3.65-3.65v-5.15c0-1.58-.49-2.63-1.5-3.18v5.33c0 3.27-1.88 5.15-5.15 5.15H5.921c.32.58.8.99 1.46 1.23z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.11 10.5c0-1.87 1.52-3.39 3.39-3.39s3.39 1.52 3.39 3.39-1.52 3.39-3.39 3.39-3.39-1.52-3.39-3.39zm1.5 0c0 1.04.85 1.89 1.89 1.89s1.89-.85 1.89-1.89-.85-1.89-1.89-1.89-1.89.85-1.89 1.89z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.031 12.7V8.3c0-.41.34-.75.75-.75s.75.34.75.75v4.4a.749.749 0 1 1-1.5 0zM15.46 12.7V8.3c0-.41.34-.75.75-.75s.75.34.75.75v4.4a.749.749 0 1 1-1.5 0z",
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVuesaxOutlineMoneys);
export default __webpack_public_path__ + "static/media/vuesax-outline-moneys.0b23b19ba8bee4ca4e22b8dc4d37fac6.svg";
export { ForwardRef as ReactComponent };